import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { QuestionRule } from 'src/app/models/question-rules/QuestionRule';
import { QuestionRuleService } from 'src/app/services/question-rule.service';
import { AssetTypeService } from 'src/app/services/asset-type.service';

@Component({
  selector: 'app-add-question-rules-modal',
  templateUrl: './add-question-rules-modal.page.html',
  styleUrls: ['./add-question-rules-modal.page.scss'],
})
export class AddQuestionRulesModalPage implements OnInit {
  public assetInScene: AssetInScene;
  public existingAssetsInScene: AssetInScene[];

  constructor(
    public modalController: ModalController,
    public questionRuleService: QuestionRuleService,
    public assetTypeService: AssetTypeService,
  ) { }

  ngOnInit() {
  }

  closeModal(){
    this.modalController.dismiss({
      'questionRules': this.assetInScene.questionRules,
    });    
  }

  getActiveQuestionRules(): QuestionRule[]{
    return this.assetInScene.questionRules.filter(q => q.toBeRemoved != true);
  }

  addQuestionRule(){
    this.assetInScene.questionRules.push(this.questionRuleService.addQuestionRule(this.assetInScene));
  }

  removeQuestionRule(questionRule: QuestionRule){
    questionRule.toBeRemoved = true;
  }

  isQuestionSetAsset(sceneAssetRelationId: number): boolean{
    var linkedAssetInScene: AssetInScene = this.existingAssetsInScene.find(a => a.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
    if(!linkedAssetInScene){
      return false;
    }
    var assetType = this.assetTypeService.getType(linkedAssetInScene.baseAsset.assetTypeId);
    if(assetType == 'QuestionSet'){
      return true;
    }else{
      return false;
    }
  }

  isToSelectAsset(questionRule: QuestionRule){
    var isToSelectAsset: boolean = true;
    var ruleType = this.questionRuleService.getQuestionRuleType(questionRule.questionRuleTypeId);
    switch(ruleType){
      case 'Restart Question':
        isToSelectAsset = false;
        break;
    }
    return isToSelectAsset;
  }

  getLinkedAssetInScene(questionRule: QuestionRule): AssetInScene {
    return this.existingAssetsInScene.find(a => a.sceneAssetRelation.sceneAssetRelationId == questionRule.linkedSceneAssetRelationId);
  }

}
